import {
  KpiEmployeeNumberImportResultView,
  KpiEmployeeNumberMappingView,
} from '../../../services/kpi-dashboard/kpi-dashboard.service'
import { normalizeSearchText } from '../../../util/search-text'

/** 削除結果を反映し、backend と同じグループ・名前・ID 順へ並べ替える。 */
export function applyEmployeeNumberDeletion(
  mappings: readonly KpiEmployeeNumberMappingView[],
  target: KpiEmployeeNumberMappingView,
): KpiEmployeeNumberMappingView[] {
  const updatedMappings = target.userActive
    ? mappings.map((mapping) =>
        mapping.userId === target.userId
          ? { ...mapping, employeeNumber: null }
          : mapping,
      )
    : mappings.filter((mapping) => mapping.userId !== target.userId)

  return updatedMappings.sort((left, right) => {
    const groupDifference = mappingGroup(left) - mappingGroup(right)
    if (groupDifference !== 0) {
      return groupDifference
    }

    return (
      left.userName.localeCompare(right.userName, 'ja') ||
      left.userId.localeCompare(right.userId)
    )
  })
}

/** 名前・メールアドレス・社員番号を NFKC・小文字へ正規化して部分一致検索する。 */
export function filterKpiEmployeeNumberMappings(
  mappings: readonly KpiEmployeeNumberMappingView[],
  searchQuery: string,
): KpiEmployeeNumberMappingView[] {
  const normalizedQuery = normalizeSearchText(searchQuery)
  if (normalizedQuery === '') {
    return [...mappings]
  }

  return mappings.filter((mapping) => {
    const employeeNumber = isEmployeeNumberUnset(mapping)
      ? ''
      : mapping.employeeNumber

    return normalizeSearchText(
      [
        mapping.userName,
        mapping.email,
        employeeNumber,
        mapping.userActive ? '' : '無効ユーザー',
      ].join('\n'),
    ).includes(normalizedQuery)
  })
}

/** 社員番号が null または undefined の行を未設定として扱う。 */
export function isEmployeeNumberUnset(
  mapping: KpiEmployeeNumberMappingView,
): boolean {
  return mapping.employeeNumber == null
}

/** ファイル全体のエラーメッセージを取得する。 */
export function getEmployeeNumberFileErrorMessage(
  result: KpiEmployeeNumberImportResultView,
): string | null {
  if (result.fileErrors.length === 0) {
    return null
  }

  return result.fileErrors.join('、')
}

/** 表示ユーザー数と社員番号未設定ユーザー数を件数チップ向けに整形する。 */
export function formatKpiEmployeeNumberCount(
  displayedCount: number,
  displayedUnsetCount: number,
  searchQuery: string,
): string {
  const prefix = normalizeSearchText(searchQuery) === '' ? '全' : '該当'
  return `${prefix} ${displayedCount} 名（未設定 ${displayedUnsetCount} 名）`
}

function mappingGroup(mapping: KpiEmployeeNumberMappingView): number {
  if (!mapping.userActive) {
    return 2
  }
  return isEmployeeNumberUnset(mapping) ? 0 : 1
}
